export default __webpack_public_path__ + "assets/images/flags-rectangular/af.svg";